<div class="icon">
    @switch (icon) {
        @case ('close-large') {
            <ui-icon-close-large/>
        }
        @case ('close-small') {
            <ui-icon-close-small/>
        }
        @case ('filters-show') {
            <ui-icon-filters-show/>
        }
        @case ('mobile-mode-list') {
            <ui-icon-mobile-mode-list/>
        }
        @case ('mobile-mode-map') {
            <ui-icon-mobile-mode-map/>
        }
        @case ('sidebar-hide') {
            <ui-icon-sidebar-hide/>
        }
        @case ('sidebar-mode-list') {
            <ui-icon-sidebar-mode-list/>
        }
        @case ('sidebar-mode-tile') {
            <ui-icon-sidebar-mode-tile/>
        }
        @case ('sidebar-show') {
            <ui-icon-sidebar-show/>
        }
        @case ('window-maximize') {
            <ui-icon-window-maximize/>
        }
        @case ('window-minimize') {
            <ui-icon-window-minimize/>
        }
    }
</div>
